import { Box, Text, useTheme } from "@chakra-ui/react";
import React from "react";
import { useAppContext } from "../../../App";
import mesa5 from "../../../innerAsstes/elementos home web/Mesa de trabajo 5.png";
import { DropdownSimple } from "../dropdownSimple/dropdownSimple";
import { formatTextForCard } from "../../../utils/functions";
import moment from "moment"

export default function SpecificCourseDescription({ 
  imgSavedSrc,
  renderSpecific = "",
  modesArray = [],
  certifications = [],
  prices = [],
  description = "",
  lastingTime
}) {
  const { isMobile } = useAppContext();
  const theme = useTheme();
  const style = styles(theme, isMobile);
  const arraySpecific = renderSpecific.split(" ");
  const title1 = arraySpecific.splice(0, 3).map((word) => `${word} `);
  const title2 = arraySpecific
    .splice(0, arraySpecific.length)
    .map((word) => `${word} `);

  const CardModes = ({ nombre: name, fechas_inicio: startDates, descripcion }) => {
    const startDateText = startDates.length > 0
      ? `Próximo Inicio: ${startDates.map( date => `${moment(date).format('DD/MM/YY')}`)}`
      : descripcion;
    return (
      <Box as="div" style={style.cardContainer} alignItems={'center'}>
        <Box style={style.imgAndName}>
          <img style={style.imgModes} src={mesa5} alt="mesa 5 modes" />
          <Text style={style.modeName}>{name}</Text>
        </Box>
        <Text style={style.startDate}>{startDateText}</Text>
      </Box>
    );
  };

  return (
    <div style={style.container}>
      <div>
        <Text style={style.titleBlue} className="sansation-bold">
          {title1}
        </Text>
        <Text style={style.title} className="sansation-bold">
          {title2}
        </Text>
        <Text style={style.description}>
           {formatTextForCard('description', description.replace(/(\r\n|\n|\r)/gm, " "), false)}
        </Text>
      </div>
      <div>
        <DropdownSimple
          componentId="duracion-drop"
          buttonText="+ DURACIÖN ESTIMADA" 
          customStyles={{
            buttonText:{
              ...style.estimate
            }
          }}
          componentToRender={() => (
            <Text fontSize={isMobile? '1rem':'1rem'} paddingTop={'0.5rem'} paddingBottom={'0.5rem'}>
              El curso será desarrollado a lo largo de {lastingTime}
            </Text>
          )}
        />
        <DropdownSimple
          componentId="modalidades-drop"
          buttonText="+ MODALIDADES DISPONIBLES"
          componentToRender={() => (
            modesArray.length === 0? <></>:
            <Box as="div" style={style.modes}>
              {modesArray?.map((item) => (
                <CardModes {...item} />
              ))}
            </Box>
          )}
          customStyles={{
            buttonText:{
              ...style.estimate
            }
          }}
        />
        <DropdownSimple
          componentId="certificaciones-drop"
          buttonText="+ CERTIFICACIONES"
          componentToRender={() => 
            <Box as="div" style={style.certificatesContainer}>
              {certifications?.map(({ imagen, nombre, descripcion }, i) => (
  <Box
    key={i}
    display="flex"
    flexDirection={isMobile ? "row" : "column"}
    alignItems={isMobile ? "center" : "start"}
    marginRight="1rem"
    marginBottom="1rem"
  >
    <img
      style={style.certificate}
      src={require(`../../../innerAsstes/Logos certificaciones/${imagen.toLowerCase()}`)}
      alt={`certificate-${i}`}
    />
    {isMobile && (
      <Text
        fontSize="0.9rem"
        color={theme.color.text.tertiary}
        marginLeft="1rem"
        maxWidth="60vw"
      >
        {descripcion}
      </Text>
    )}
  </Box>
))}

            </Box>
          }
          customStyles={{
            buttonText:{
              ...style.estimate
            }
          }}
        />
      </div>
    </div>
  );
}

const styles = (theme, isMobile) => ({
  container: {
    display: 'flex',
    flexDirection: "column",
    justifyContent: "space-between",
    width: isMobile? "100%":'55%',
  },
  title:{
    textAlign: "left",
    fontSize: isMobile? '2.5rem':'2rem',
    fontWeight: 'bold',
    color: theme.color.text.tertiary
  },
  titleBlue:{
    textAlign: "left",
    fontSize: isMobile? "2.5rem":'2rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: theme.color.text.secondary
  },
  description:{
    fontSize: isMobile? '1rem':'1rem',
    lineHeight: '2',
    textAlign: 'justify',
    paddingBottom: '2rem',
    borderBottomWidth: 1,
    borderBottomColor: theme.color.text.secondary,
  },
  estimate:{
    padding: '0.5rem',
    fontSize: '1rem',
    color: theme.color.text.secondary,
    borderBottomWidth: 1,
    borderBottomColor: theme.color.text.secondary,
  },
  certificatesContainer:{
    display: 'flex',
    flexDirection: isMobile?'column':'row',
    overflowX: 'auto', 
    paddingBottom: '1rem',
  },
  certificate:{
    maxWidth: '20vw',
    maxHeight: '80px',     // Limita la altura máxima, pero mantiene proporción
    height: 'auto',         // Mantiene la proporción original
    marginTop: '1rem',
    marginBottom: '1rem',
    marginRight: '1rem',
    display: 'block',       // Opcional, para mejor alineación

  },
  modes:{
    display: 'flex',
    flexDirection: isMobile? 'column':'row',
    justifyContent: 'space-between',
    paddingTop: '1rem',
    borderBottomWidth: 1,
    borderBottomColor: theme.color.text.secondary,
  },
  cardContainer:{
    width: isMobile?'100%':'40%',
    marginBottom: '1rem',
    padding: '1rem',
    paddingBottom: '0.5rem',
    border: '1px solid',
    borderColor: theme.color.text.secondary,
  },
  imgAndName:{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf:'center',
  },
  imgModes:{
    width: isMobile?'10vw':'5vw',
    height: isMobile?'10vw':'5vw',
    borderRadius: '10%',
  },
  modeName:{
    fontSize: '1rem',
    marginLeft: '1rem',
    color: theme.color.text.secondary
  },
  startDate:{
    display: 'flex',
    fontSize: '1rem',
    weight: 'bold',
    alignItems: 'center',
    color: theme.color.text.secondary
  }
});
